import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import LightbulbIcon from '@mui/icons-material/Lightbulb';

// Mapping type to icon and color
const typeConfig = {
  RISK: {
    icon: <WarningAmberIcon color="error" fontSize="large" />,
    label: 'Risque',
  },
  OPTIMIZATION: {
    icon: <TrendingUpIcon color="primary" fontSize="large" />,
    label: 'Optimisation',
  },
  OPPORTUNITY: {
    icon: <LightbulbIcon color="success" fontSize="large" />,
    label: 'Opportunité',
  },
};

export interface Insight {
  type: 'RISK' | 'OPTIMIZATION' | 'OPPORTUNITY';
  signal: string;
  implication: string;
  action: string;
}

interface InsightCardProps {
  insight: Insight;
}

const InsightCard: React.FC<InsightCardProps> = ({ insight }) => {
  const config = typeConfig[insight.type] || typeConfig.RISK;
  return (
    <Card variant="outlined" sx={{ mb: 2, minWidth: 275 }}>
      <CardContent>
        <Box display="flex" alignItems="center" mb={1}>
          {config.icon}
          <Typography variant="h6" sx={{ ml: 1 }}>
            {config.label}
          </Typography>
        </Box>
        <Typography variant="subtitle1" gutterBottom>
          {insight.signal}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {insight.implication}
        </Typography>
        <Typography variant="body2" color="primary" fontWeight="bold">
          {insight.action}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default InsightCard;
